import { Component, Inject, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { JobService } from 'src/app/core/services/job.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { GenericService } from 'src/app/core/services/generic.service';
import { DisplayOnMultiSelectPipe } from 'src/app/core/pipes/display-on-multi-select.pipe';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { RequisitionsQueryFilter } from './requisitions-query-filter.model';
import { RequisitionsInfiniteScrollContainer } from './requisitions-infinite-scroll-container';
import { RequisitionDisplaySelectedFilter } from './requisition-display-selected-filter.model';
import { SharedAjsService } from 'src/app/core/services/shared-ajs.service';

@Component({
  selector: 'app-requisitions-page',
  templateUrl: './requisitions-page.component.html',
  styleUrls: ['./requisitions-page.component.css'],
  providers: [DisplayOnMultiSelectPipe]
})
export class RequisitionsPageComponent implements OnInit {

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  @Input() $transition$: any;

  $stateParams: any;
  userId: any;
  companyId: any;
  companyState: any;
  companyType: any;
  isCompanyVendor!: boolean;
  isStaffingCompany!: boolean;
  isClient!: boolean;
  clientOfBuSortValue!: string;

  requisitionsContainer: RequisitionsInfiniteScrollContainer;
  savedFilters: any;
  isRowViewActive!: boolean;
  currentRequisitionPage!: number;
  private lastFetchedRequisitionPage!: number;

  activityMap: any[] = [];
  salaryDurationOptions: any[] = [];
  jobTypeList: any[] = [];
  skeletonPlaceholders = Array(6).fill(0);

  isFiltersChanged = false;
  loadingClientsOrBUs = false;
  loadingRoles = false;
  loadingRequisitionStatuses = false;
  loadingRequisitionNumbers = false;
  loadingRecruiters = false;
  loadingWorkLocations = false;

  clientsOrBusList: any[] = [];
  selectedClientsOrBus: any[] = [];
  rolesList: any[] = [];
  selectedRoles: any[] = [];
  requisitionTypes: any[] = [];
  selectedRequisitionTypes: any[] = [];
  statusList: any[] = [];
  selectedStatuses: any[] = [];
  requisitionNumbersList: any[] = [];
  selectedRequisitionNumbers: any[] = [];
  recruitersList: any[] = [];
  selectedRecruiters: any[] = [];
  selectedJobTypes: any[] = [];
  workLocationList: any[] = [];
  selectedWorkLocations: any[] = [];

  displayRequisitionSelectedFilter: RequisitionDisplaySelectedFilter;
  savedDisplayedRequisitionSelectedFilter: any;
  displayRequisitionFilterItemsSelected: any[] = [];
  displayFilterFlag = false;
  emptySelectedFilter = false;
  showDisplaySelectedFilterPanel = false;
  displaySelectedFilterObj: any;
  showFilterDeleteIcon: any = null;

  requisitionSortByFilters: any[] = [];
  selectedSort = 'Please Select';
  selectedSortDir = '';
  selectedDateRange = '';

  showFiltersPanel = false;

  constructor(
    private jobService: JobService,
    private companyService: CompanyService,
    private candidateService: CandidateService,
    private stateManagementStorageService: StateManagementStorageService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private authService: AuthService,
    private genericService: GenericService,
    private displayOnMultiSelectPipe: DisplayOnMultiSelectPipe,
    public $state: StateService,
    @Inject(SharedAjsService) public sharedAjsService: SharedAjsService
  ) { }

  ngOnInit(): void {
    this.$stateParams = this.$transition$.params();
    this.init();
  }

  init(): void {
    const userDetails = this.authService.getUserDetails();
    this.userId = userDetails.id;
    this.companyId = userDetails.company.companyId;
    this.companyState = userDetails.company.companyState;
    this.companyType = userDetails.company.companyType;
    this.isCompanyVendor = this.companyService.isCompanyVendor();
    this.isStaffingCompany = this.companyService.isStaffingCompany();

    if (this.isStaffingCompany) {
      this.isClient = true;
      this.clientOfBuSortValue = 'Client';
    } else {
      this.isClient = false;
      this.clientOfBuSortValue = 'BU';
    }

    this._getDetailsNeededForRequisitionCards();

    const filter = new RequisitionsQueryFilter(this.companyId);
    if (this.$stateParams.requisitionStatesArray !== null && this.$stateParams.requisitionStatesArray !== undefined) {
      filter.requisitionStates = this.$stateParams.requisitionStatesArray.map((val: string) => val.toUpperCase());
    }

    this.requisitionsContainer = new RequisitionsInfiniteScrollContainer(
      this.userId, this.companyId, this.jobService, this.alertsAndNotificationsService, this.isStaffingCompany
    );
    this.requisitionsContainer.requisitionsQueryFilter = { ...filter };

    // Remove requisition screen on company switch (in super user)
    this._checkAndRemoveIfFilterExistsWithCompanyId();

    const savedFilters = this.stateManagementStorageService.getScreenState(`requisitionsScreen-${this.userId}`);
    if (savedFilters && filter.requisitionStates.length === 0) {
      this.requisitionsContainer.requisitionsQueryFilter = { ...savedFilters };
      this.savedFilters = { ...savedFilters };
    } else {
      this.stateManagementStorageService.setScreenState(`requisitionsScreen-${this.userId}`, filter);
    }

    this.displayRequisitionSelectedFilter = new RequisitionDisplaySelectedFilter();
    const savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState(
      `requisitionsScreen-displayFilter-${this.userId}`
    );
    if (savedDisplayedRequisitionSelectedFilter) {
      this.displayRequisitionSelectedFilter = { ...savedDisplayedRequisitionSelectedFilter };
      this.displayRequisitionSelectedFilter.selectedFilterSort = '';
      this.savedDisplayedRequisitionSelectedFilter = { ...savedDisplayedRequisitionSelectedFilter };
      if (this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag === undefined) {
        this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = true;
      }
      this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    } else {
      this.stateManagementStorageService.setScreenState(
        `requisitionsScreen-displayFilter-${this.userId}`, this.displayRequisitionSelectedFilter
      );
      this.savedDisplayedRequisitionSelectedFilter = { ...this.displayRequisitionSelectedFilter };
    }
    this.showDisplaySelectedFilterPanel = this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag;

    this.setReRunScoreFilters(filter);

    this.currentRequisitionPage = 1;
    this.isRowViewActive = false;
    this._setRequisitionRowViewStatus();
    if (!this.isRowViewActive) {
      this.requisitionsContainer.getNext();
    }

    this._setRequisitionTypes();
    this._setRequisitionSortByFilter();
    this._getAndSetFilters();

    if (this.$stateParams.loginParamsObject && this.$stateParams.loginParamsObject.redirect === 'documents') {
      this._openCandidateBookletDocumentsModal();
    }
  }

  setReRunScoreFilters(filter: RequisitionsQueryFilter): void {
    if (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber) {
      this.requisitionsContainer.requisitionsQueryFilter = { ...filter };
      this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [this.$stateParams.userParamsObject.requisitionNumber];
      this.stateManagementStorageService.setScreenState(
        `requisitionsScreen-${this.userId}`, this.requisitionsContainer.requisitionsQueryFilter
      );
      this.savedFilters = this.requisitionsContainer.requisitionsQueryFilter;

      this.displayRequisitionSelectedFilter = new RequisitionDisplaySelectedFilter();
      this.displayRequisitionSelectedFilter.requisitionNums = this.requisitionsContainer.requisitionsQueryFilter.requisitionNums;
      this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      this.stateManagementStorageService.setScreenState(
        `requisitionsScreen-displayFilter-${this.userId}`, this.displayRequisitionSelectedFilter
      );
      this.savedDisplayedRequisitionSelectedFilter = { ...this.displayRequisitionSelectedFilter };
    }
  }

  _openCandidateBookletDocumentsModal(): void {
    const actionType = 'candidateBooklet';
    const actionLabel = this.$stateParams.loginParamsObject + '\'s Booklet';
    this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, this.$stateParams.loginParamsObject);
  }

  onRequisitionCopied(): void {
    // The reload can interrupt the action modal's close, leaving its scroll lock on the body.
    this.$state.reload().then(() => {
      document.body.classList.remove('modal-open');
      document.body.style.paddingRight = '';
    });
  }

  uploadRequisition(): void {
    if (this.isStaffingCompany && (!this.clientsOrBusList || this.clientsOrBusList.length === 0)) {
      const message = 'Please setup atleast one client in \'Manage Client\' before creating a Requisition.';
      this.alertsAndNotificationsService.showCustomConfirm('Add Client', 'Cancel', 'No Clients', message, 'warning', 'medium', () => {
        this.$state.go('missioncontrol.clientsOrBus', { reload: true });
      }, () => { });
    } else {
      this.$state.go('missioncontrol.uploadreq', { jobState: 'Draft' });
    }
  }

  toggleFiltersPanel(): void {
    this.showFiltersPanel = !this.showFiltersPanel;
  }

  addToDisplayFilters(event: string): void {
    if (event === 'search') {
      this.displayRequisitionSelectedFilter.searchString = this.requisitionsContainer.requisitionsQueryFilter.searchText;
      this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
  }

  onGlobalFilterChange(event?: KeyboardEvent): void {
    this.isFiltersChanged = true;
    if (!this.showFiltersPanel) {
      this.showFiltersPanel = true;
    }
    if (this._onEnterKeyPress(event)) {
      this.addToDisplayFilters('search');
      this.queryRequisitions();
    }
  }

  _onEnterKeyPress(event?: KeyboardEvent): boolean {
    return !!event && event.keyCode === 13;
  }

  _setRequisitionSortByFilter(): void {
    this.requisitionSortByFilters = [
      { column: 'clientorbu', columnDisplayName: this.clientOfBuSortValue },
      { column: 'title', columnDisplayName: 'Role' },
      { column: 'requisitionState', columnDisplayName: 'Requisition Status' },
      { column: 'requisitionNumber', columnDisplayName: 'Requisition Number' },
      { column: 'updatedDate', columnDisplayName: 'Updated Date' }
    ];
    if (this.savedFilters && this.savedFilters.sortColumn !== '' && this.savedFilters.sortDirection !== '') {
      const savedSortColumn = this.savedFilters.sortColumn + ' ' + this.savedFilters.sortDirection;
      const savedSelectedSort = this.savedFilters.sortDirection.slice(0, 1) + this.savedFilters.sortDirection.slice(1).toLowerCase();
      let savedSortDirection = '';
      this.requisitionSortByFilters.forEach(filter => {
        if (filter.column === this.savedFilters.sortColumn) {
          savedSortDirection = filter.columnDisplayName;
        }
      });
      this.sortRequisitions(savedSortColumn, savedSortDirection, savedSelectedSort);
    }
  }

  _setRequisitionTypes(): void {
    this.requisitionTypes = [{ name: 'Shared', value: 'SHARED' }];
    if (this.isStaffingCompany) {
      this.requisitionTypes.push({ name: 'External', value: 'EXTERNAL' });
    } else {
      this.requisitionTypes.push({ name: 'Internal', value: 'INTERNAL' });
    }
    if (this.savedFilters) {
      this.selectedRequisitionTypes = this.requisitionTypes.filter(type =>
        this.savedFilters.requisitionTypes.some((value: any) => value === type.value));
    }
  }

  _getAndSetFilters(): void {
    this.getClientsOrBus(() => {
      this.getRoles('all');
      this.getRequisitionNumbers('all', () => {
        this.getRecruiters();
        this.getRequisitionStatusTypes();
        this.getWorkLocations();
      });
    });
  }

  getClientsOrBus(successCallback?: () => void): void {
    this.loadingClientsOrBUs = true;
    const userDetails = this.authService.getUserDetails();
    this.candidateService.getAllClientsOrBu(userDetails, (data: any) => {
      this.clientsOrBusList = data;
      if (this.savedFilters) {
        this.selectedClientsOrBus = this.clientsOrBusList.filter((clientOrBu: any) =>
          this.savedFilters.clientOrBU.some((id: any) => id === clientOrBu.id));
      }
      if (this.savedDisplayedRequisitionSelectedFilter.clientOrBU.length !== 0
        || this.requisitionsContainer.requisitionsQueryFilter.clientOrBU.length !== 0) {
        this.displayRequisitionSelectedFilter.clientOrBU = this.selectedClientsOrBus.map((val: any) =>
          val.companyType === 'Corporation' ? val.shortName : val.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      }
      this.loadingClientsOrBUs = false;
      if (successCallback) { successCallback(); }
    }, (error: any) => {
      this.loadingClientsOrBUs = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getRoles(searchText: string, successCallback?: () => void): void {
    this.normalizeSelections();
    this.loadingRoles = true;
    this.selectedRoles = [];
    const clientOrBuIds = this.selectedClientsOrBus.map(clientOrBu => clientOrBu.id);
    this.jobService.getRoles(this.userId, this.companyId, searchText, { clientOrBuIds }, (data: any) => {
      this.rolesList = [];
      data.forEach((val: string) => {
        if (val !== null && !this.rolesList.find(role => role.name === val)) {
          this.rolesList.push({ name: val, selectedDisplayName: this.displayOnMultiSelectPipe.transform(val) });
        }
      });
      if (this.savedFilters) {
        this.selectedRoles = this.rolesList.filter(role => this.savedFilters.roleList.some((name: any) => name === role.name));
      }
      if (this.savedDisplayedRequisitionSelectedFilter.roleList.length !== 0
        || this.requisitionsContainer.requisitionsQueryFilter.roleList.length !== 0) {
        this.displayRequisitionSelectedFilter.roleList = this.selectedRoles.map(role => role.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      }
      this.loadingRoles = false;
      if (successCallback) { successCallback(); }
    }, (error: any) => {
      this.loadingRoles = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getRequisitionNumbers(searchText: string, successCallback?: () => void): void {
    this.normalizeSelections();
    this.loadingRequisitionNumbers = true;
    this.selectedRequisitionNumbers = [];
    const clientOrBuIds = this.selectedClientsOrBus.map(clientOrBu => clientOrBu.id);
    const roleNames = this.selectedRoles.map(role => role.name);
    this.jobService.searchByReqNum(this.userId, this.companyId, searchText, { clientOrBuIds, roleNames }, (data: any) => {
      this.requisitionNumbersList = data.map((req: any) => ({
        name: req.reqNumber,
        icon: req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>',
        selectedDisplayName: this.displayOnMultiSelectPipe.transform(req.reqNumber)
      }));
      if (this.savedFilters) {
        this.selectedRequisitionNumbers = this.requisitionNumbersList.filter(reqNumber =>
          this.savedFilters.requisitionNums.some((name: any) => name === reqNumber.name));
      }
      if (this.savedDisplayedRequisitionSelectedFilter.requisitionNums.length !== 0
        || this.requisitionsContainer.requisitionsQueryFilter.requisitionNums.length !== 0) {
        this.displayRequisitionSelectedFilter.requisitionNums = this.selectedRequisitionNumbers.map(reqNumber => reqNumber.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      }
      this.loadingRequisitionNumbers = false;
      if (successCallback) { successCallback(); }
    }, (error: any) => {
      this.loadingRequisitionNumbers = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onReqNumsSearch(event: any): void {
    this.getRequisitionNumbers(event && event.term ? event.term : 'all');
  }

  getRecruiters(successCallback?: () => void): void {
    this.normalizeSelections();
    this.loadingRecruiters = true;
    this.selectedRecruiters = [];
    const userDetails = this.authService.getUserDetails();
    const clientOrBuIds = this.selectedClientsOrBus.map(clientOrBu => clientOrBu.id);
    const requisitionNumbers = this.selectedClientsOrBus.length > 0 ? this.requisitionNumbersList.map(req => req.name) : [];
    this.jobService.getAllRecruiters(
      userDetails, userDetails.company, null, null, clientOrBuIds, requisitionNumbers, false, (data: any) => {
      const list: any[] = [];
      data.recruiters.forEach((recruiter: any) => {
        const name = recruiter.lastName !== null ? recruiter.firstName + ' ' + recruiter.lastName : recruiter.firstName;
        if (!list.find(item => item.name === name)) {
          list.push({ name, id: recruiter.userId, selectedDisplayName: this.displayOnMultiSelectPipe.transform(name) + ' <sup>R</sup>' });
        }
      });
      data.hiringManagers.forEach((manager: any) => {
        const name = manager.lastName !== null ? manager.firstName + ' ' + manager.lastName : manager.firstName;
        if (!list.find(item => item.name === name)) {
          list.push({ name, id: manager.userId, selectedDisplayName: this.displayOnMultiSelectPipe.transform(name) + ' <sup>H</sup>' });
        }
      });
      data.pocs.forEach((poc: any) => {
        if (poc) {
          const name = poc.lastName !== null ? poc.firstName + ' ' + poc.lastName : poc.firstName;
          if (!list.find(item => item.name === name)) {
            list.push({ name, id: poc.userId, selectedDisplayName: this.displayOnMultiSelectPipe.transform(name) + ' <sup>POC</sup>' });
          }
        }
      });
      this.recruitersList = list;
      if (this.savedFilters) {
        this.selectedRecruiters = this.recruitersList.filter(recruiter =>
          this.savedFilters.recruiters.some((id: any) => id === recruiter.id));
      }
      if (this.savedDisplayedRequisitionSelectedFilter.recruiters.length !== 0
        || this.requisitionsContainer.requisitionsQueryFilter.recruiters.length !== 0) {
        this.displayRequisitionSelectedFilter.recruiters = this.selectedRecruiters.map(recruiter => recruiter.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      }
      this.loadingRecruiters = false;
      if (successCallback) { successCallback(); }
    }, (error: any) => {
      this.loadingRecruiters = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getRequisitionStatusTypes(): void {
    this.loadingRequisitionStatuses = true;
    this.jobService.getAllStatusTypes((data: any) => {
      this.statusList = data;
      if (this.$stateParams.requisitionStatesArray) {
        this.statusList.forEach((status: any) => {
          if (this.$stateParams.requisitionStatesArray.some((val: string) => val.toUpperCase() === status.name.toUpperCase())) {
            status.ticked = true;
          }
        });
      }
      if (this.savedFilters) {
        this.selectedStatuses = this.statusList.filter((status: any) =>
          this.savedFilters.requisitionStates.some((name: any) => name === status.name.toUpperCase()));
      }
      if (this.savedDisplayedRequisitionSelectedFilter.requisitionStates.length !== 0
        || this.requisitionsContainer.requisitionsQueryFilter.requisitionStates.length !== 0) {
        this.displayRequisitionSelectedFilter.requisitionStates = this.selectedStatuses.map((status: any) => status.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      }
      this.loadingRequisitionStatuses = false;
    }, (error: any) => {
      this.loadingRequisitionStatuses = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getWorkLocations(): void {
    this.loadingWorkLocations = true;
    this.jobService.getWorkLocations((data: any) => {
      this.workLocationList = data.filter((location: any) => location.id !== 'NO_WORK_LOCATION');
      if (this.savedFilters && this.savedFilters.workLocationIds) {
        this.selectedWorkLocations = this.workLocationList.filter((location: any) =>
          this.savedFilters.workLocationIds.some((id: any) => id === location.id));
      }
      if (this.savedDisplayedRequisitionSelectedFilter.workLocationIds.length !== 0
        || this.requisitionsContainer.requisitionsQueryFilter.workLocationIds.length !== 0) {
        this.displayRequisitionSelectedFilter.workLocationIds = this.selectedWorkLocations.map((location: any) => location.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      }
      this.loadingWorkLocations = false;
    }, () => {
      this.loadingWorkLocations = false;
    });
  }

  getMultiSelectSummary(items: any[], bindLabel: string): string {
    if (!items || items.length === 0) { return ''; }
    const firstLabel = items[0][bindLabel];
    return items.length > 1 ? `${firstLabel} ... (${items.length})` : firstLabel;
  }

  selectRemoveAll(label: string, type: string): void {
    const selectAll = type === 'selectAll';
    switch (label) {
      case this.MESSAGECONSTANTS.LABLES.CLIENT:
      case this.MESSAGECONSTANTS.LABLES.BU:
        this.selectedClientsOrBus = selectAll ? [...this.clientsOrBusList] : [];
        this.onClientClick();
        break;
      case this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE:
        this.selectedRoles = selectAll ? [...this.rolesList] : [];
        this.onRoleClick();
        break;
      case 'requisitionType':
        this.selectedRequisitionTypes = selectAll ? [...this.requisitionTypes] : [];
        this.onRequisitionTypeClick();
        break;
      case this.MESSAGECONSTANTS.LABLES.REQUISITION_STATUS:
        this.selectedStatuses = selectAll ? [...this.statusList] : [];
        this.onRequisitionStatusClick();
        break;
      case this.MESSAGECONSTANTS.LABLES.REQ_NUMBER:
        this.selectedRequisitionNumbers = selectAll ? [...this.requisitionNumbersList] : [];
        this.onRequisitionNumberClick();
        break;
      case this.MESSAGECONSTANTS.LABLES.RECRUITER:
        this.selectedRecruiters = selectAll ? [...this.recruitersList] : [];
        this.onRecruiterClick();
        break;
      case 'Job Type':
        this.selectedJobTypes = selectAll ? [...this.jobTypeList] : [];
        this.onJobTypeClick();
        break;
      case 'Work Location':
        this.selectedWorkLocations = selectAll ? [...this.workLocationList] : [];
        this.onWorkLocationClick();
        break;
      default:
        break;
    }
  }

  private normalizeSelections(): void {
    this.selectedClientsOrBus = this.selectedClientsOrBus || [];
    this.selectedRoles = this.selectedRoles || [];
    this.selectedRequisitionTypes = this.selectedRequisitionTypes || [];
    this.selectedStatuses = this.selectedStatuses || [];
    this.selectedRequisitionNumbers = this.selectedRequisitionNumbers || [];
    this.selectedRecruiters = this.selectedRecruiters || [];
    this.selectedJobTypes = this.selectedJobTypes || [];
    this.selectedWorkLocations = this.selectedWorkLocations || [];
  }

  onClientClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.getRoles('all', () => {
      this.getRequisitionNumbers('all', () => {
        this.getRecruiters(() => {
          this.normalizeSelections();
          this.requisitionsContainer.requisitionsQueryFilter.clientOrBU = this.selectedClientsOrBus.map(clientOrBu => clientOrBu.id);
          this.requisitionsContainer.requisitionsQueryFilter.roleList = [];
          this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [];
          this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];

          this.displayRequisitionSelectedFilter.clientOrBU = this.selectedClientsOrBus.map((val: any) =>
            val.companyType === 'Corporation' ? val.shortName : val.name);
          this.displayRequisitionSelectedFilter.roleList = [];
          this.displayRequisitionSelectedFilter.recruiters = [];
          this.displayRequisitionSelectedFilter.requisitionNums = [];
          this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        });
      });
    });
  }

  onRoleClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.getRequisitionNumbers('all', () => {
      this.getRecruiters(() => {
        this.requisitionsContainer.requisitionsQueryFilter.roleList = this.selectedRoles.map(role => role.name);
        this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [];
        this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];

        this.displayRequisitionSelectedFilter.roleList = this.requisitionsContainer.requisitionsQueryFilter.roleList;
        this.displayRequisitionSelectedFilter.recruiters = [];
        this.displayRequisitionSelectedFilter.requisitionNums = [];
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
      });
    });
  }

  onRequisitionTypeClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.requisitionTypes = this.selectedRequisitionTypes.map(type => type.value);
    this.displayRequisitionSelectedFilter.requisitionTypes = this.selectedRequisitionTypes.map(type => type.name);
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  onRequisitionStatusClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.requisitionStates = this.selectedStatuses.map(status => status.name.toUpperCase());
    this.displayRequisitionSelectedFilter.requisitionStates = this.selectedStatuses.map(status => status.name);
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  onRequisitionNumberClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = this.selectedRequisitionNumbers.map(reqNumber => reqNumber.name);
    this.displayRequisitionSelectedFilter.requisitionNums = this.requisitionsContainer.requisitionsQueryFilter.requisitionNums;
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  onRecruiterClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.recruiters = this.selectedRecruiters.map(recruiter => recruiter.id);
    this.displayRequisitionSelectedFilter.recruiters = this.selectedRecruiters.map(recruiter => recruiter.name);
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  onJobTypeClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.jobTypes = this.selectedJobTypes.map(type => type.value);
    this.displayRequisitionSelectedFilter.jobTypes = this.selectedJobTypes.map(type => type.name);
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  onWorkLocationClick(): void {
    this.normalizeSelections();
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.workLocationIds = this.selectedWorkLocations.map(location => location.id);
    this.displayRequisitionSelectedFilter.workLocationIds = this.selectedWorkLocations.map(location => location.name);
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  isFilterValueArray(value: any): boolean {
    return Array.isArray(value);
  }

  _setObjectVariableName(currentObject: any): void {
    const selectedFilterVariableNameObj: any = {
      clientOrBU: 'Belongs To', roleList: 'Role', requisitionTypes: 'Requisition Type',
      requisitionStates: 'Requisition Status', requisitionNums: 'Requisition Number', recruiters: 'Recruiter/Hiring Manager',
      jobTypes: 'Job Type', workLocationIds: 'Work Location', selectedFilterSort: 'Sort By', searchString: 'Search'
    };
    if (currentObject.variable in selectedFilterVariableNameObj) {
      this.displaySelectedFilterObj.variable = selectedFilterVariableNameObj[currentObject.variable];
    }
  }

  setRequisitionDisplayedFilterItemSelected(itemsSelected: any): void {
    this.emptySelectedFilter = false;
    Object.keys(itemsSelected).forEach((key: string) => {
      const obj = itemsSelected[key];
      if (obj.length > 0) {
        this.displayFilterFlag = true;
        this.displaySelectedFilterObj = {};

        if (this.displayRequisitionFilterItemsSelected.length !== 0) {
          this.displayRequisitionFilterItemsSelected.forEach((filterItem: any) => {
            if (filterItem.filter === key) {
              if (filterItem.setSelectedFilterLimit === 5) {
                this.displaySelectedFilterObj = {
                  filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false
                };
              } else {
                this.displaySelectedFilterObj = {
                  filter: key, variable: key, value: obj,
                  setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter
                };
              }
            }
          });
        }

        if (this.displayRequisitionFilterItemsSelected.length === 0 || Object.keys(this.displaySelectedFilterObj).length === 0) {
          this.displaySelectedFilterObj = {
            filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false
          };
        }

        this._setObjectVariableName(this.displaySelectedFilterObj);

        if (this.displayRequisitionFilterItemsSelected.length > 0) {
          this.displayRequisitionFilterItemsSelected = this.displayRequisitionFilterItemsSelected.filter(
            item => item.variable !== this.displaySelectedFilterObj.variable
          );
        }
        this.displayRequisitionFilterItemsSelected.push(this.displaySelectedFilterObj);
      } else {
        if (this.displayRequisitionFilterItemsSelected.length > 0) {
          this.displayRequisitionFilterItemsSelected = this.displayRequisitionFilterItemsSelected.filter(item => item.filter !== key);
        }
      }
    });
    if (this.displayRequisitionFilterItemsSelected.length === 0) {
      if (!this.requisitionsContainer.isFilterOn) {
        this.displayFilterFlag = false;
        this._setShowDisplayFilterIcon(true);
      } else {
        this.emptySelectedFilter = true;
      }
    }
  }

  _setShowDisplayFilterIcon(flag: boolean): void {
    const savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState(
      `requisitionsScreen-displayFilter-${this.userId}`
    );
    savedDisplayedRequisitionSelectedFilter.showDisplayFilterIconFlag = flag;
    this.stateManagementStorageService.setScreenState(
      `requisitionsScreen-displayFilter-${this.userId}`, savedDisplayedRequisitionSelectedFilter
    );
    if (this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag !== flag) {
      this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = flag;
    }
  }

  displaySelectedFilterToggle(): void {
    this.showDisplaySelectedFilterPanel = true;
    if (this.displayFilterFlag) {
      this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = !this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag;
    }
    this._setShowDisplayFilterIcon(this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag);
  }

  _deleteSelectedItem(currentObject: any, deletedItem: any): void {
    switch (currentObject.variable) {
      case 'searchString':
        this.requisitionsContainer.requisitionsQueryFilter.searchText = '';
        this.displayRequisitionSelectedFilter.searchString = '';
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        break;
      case 'clientOrBU':
        this.clientsOrBusList.forEach((clientOrBu: any) => {
          if (clientOrBu.name === deletedItem || clientOrBu.shortName === deletedItem) {
            this.selectedClientsOrBus = this.selectedClientsOrBus.filter(item => item.name !== deletedItem);
          }
        });
        this.onClientClick();
        break;
      case 'roleList':
        this.selectedRoles = this.selectedRoles.filter(item => item.name !== deletedItem);
        this.onRoleClick();
        break;
      case 'requisitionTypes':
        this.selectedRequisitionTypes = this.selectedRequisitionTypes.filter(item => item.name !== deletedItem);
        this.onRequisitionTypeClick();
        break;
      case 'requisitionStates':
        this.selectedStatuses = this.selectedStatuses.filter(item => item.name !== deletedItem);
        this.onRequisitionStatusClick();
        break;
      case 'requisitionNums':
        this.selectedRequisitionNumbers = this.selectedRequisitionNumbers.filter(item => item.name !== deletedItem);
        this.onRequisitionNumberClick();
        break;
      case 'recruiters':
        this.selectedRecruiters = this.selectedRecruiters.filter(item => item.name !== deletedItem);
        this.onRecruiterClick();
        break;
      case 'jobTypes':
        this.selectedJobTypes = this.selectedJobTypes.filter(item => item.name !== deletedItem);
        this.onJobTypeClick();
        break;
      case 'workLocationIds':
        this.selectedWorkLocations = this.selectedWorkLocations.filter(item => item.name !== deletedItem);
        this.onWorkLocationClick();
        break;
      case 'selectedFilterSort':
        this.sortRequisitions('', 'Please Select', '');
        break;
      default:
        break;
    }
  }

  deleteSelectedFilterItem(deletedItem: any): void {
    Object.keys(this.displayRequisitionSelectedFilter).forEach((key: string) => {
      const obj = (this.displayRequisitionSelectedFilter as any)[key];
      if (Array.isArray(obj)) {
        if (obj.includes(deletedItem)) {
          this._deleteSelectedItem({ variable: key, value: obj }, deletedItem);
        }
      } else if (obj === deletedItem) {
        this._deleteSelectedItem({ variable: key, value: obj }, deletedItem);
      }
    });
  }

  sortRequisitions(sortColumn: string, selectedSort: string, selectedSortDir: string): void {
    this.isFiltersChanged = true;
    this.selectedSort = selectedSort;
    this.selectedSortDir = selectedSortDir;
    this.requisitionsContainer.requisitionsQueryFilter.sortColumn = '';
    this.requisitionsContainer.requisitionsQueryFilter.sortDirection = '';
    if (sortColumn) {
      const parts = sortColumn.split(' ');
      this.requisitionsContainer.requisitionsQueryFilter.sortColumn = parts[0];
      this.requisitionsContainer.requisitionsQueryFilter.sortDirection = parts[1];
    }

    this.displayRequisitionSelectedFilter.selectedFilterSort = '';
    if (selectedSort !== 'Please Select') {
      this.displayRequisitionSelectedFilter.selectedFilterSort = selectedSort + ' ' + '(' + selectedSortDir + ')';
    }
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  sortByDate(daterange: string): void {
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter.fromDate = '';
    this.requisitionsContainer.requisitionsQueryFilter.toDate = '';
    if (daterange) {
      const parts = daterange.split('-');
      this.requisitionsContainer.requisitionsQueryFilter.fromDate = parts[0];
      this.requisitionsContainer.requisitionsQueryFilter.toDate = parts[1];
    } else {
      this.selectedDateRange = '';
    }
  }

  resetFilterData(): void {
    this.isFiltersChanged = true;
    this.requisitionsContainer.requisitionsQueryFilter = new RequisitionsQueryFilter(this.companyId);
    this.selectedSort = 'Please Select';
    this.selectedClientsOrBus = [];
    this.selectedRoles = [];
    this.selectedRequisitionTypes = [];
    this.selectedStatuses = [];
    this.selectedRequisitionNumbers = [];
    this.selectedRecruiters = [];
    this.selectedJobTypes = [];
    this.selectedWorkLocations = [];

    this.displayRequisitionSelectedFilter = new RequisitionDisplaySelectedFilter();
    const savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState(
      `requisitionsScreen-displayFilter-${this.userId}`
    );
    this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = savedDisplayedRequisitionSelectedFilter.showDisplayFilterIconFlag;
    this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
  }

  _getDetailsNeededForRequisitionCards(): void {
    this.jobService.getActivityTypes((data: any) => {
      this.activityMap = [];
      data.forEach((val: any) => {
        this.activityMap[val.value] = val.name;
      });
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });

    this.jobService.getSalaryDurationOptions((data: any) => {
      this.salaryDurationOptions = data;
    }, () => {
      // do nothing
    });

    this.jobService.getAllJobTypes((data: any) => {
      this.jobTypeList = data;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _checkAndRemoveIfFilterExistsWithCompanyId(): void {
    const existingRequisitionScreenState = this.stateManagementStorageService.getScreenState(`requisitionsScreen-${this.userId}`);
    if (existingRequisitionScreenState && existingRequisitionScreenState.companyId !== this.companyId) {
      this.stateManagementStorageService.clearStateScreen(`requisitionsScreen-${this.userId}`);
      this.stateManagementStorageService.clearStateScreen(`requisitionsScreen-displayFilter-${this.userId}`);
    }
  }

  _setRequisitionRowViewStatus(): void {
    const checkIfRowViewActive = this.stateManagementStorageService.getScreenState(`requisitionsScreen-rowView-${this.userId}`);
    if (checkIfRowViewActive) {
      this.isRowViewActive = checkIfRowViewActive.isRowViewActive;
      if (this.isRowViewActive) {
        this.lastFetchedRequisitionPage = this.currentRequisitionPage;
        this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
      }
    }
  }

  toggleRequisitionRowView(): void {
    this.isRowViewActive = !this.isRowViewActive;
    this.stateManagementStorageService.setScreenState(
      `requisitionsScreen-rowView-${this.userId}`, { isRowViewActive: this.isRowViewActive }
    );
    if (this.isRowViewActive) {
      this.lastFetchedRequisitionPage = this.currentRequisitionPage;
      this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
    } else {
      this.requisitionsContainer.requisitionsExistFlag = true;
      this.requisitionsContainer.requisitionsQueryFilter.pageNum = 1;
      this.requisitionsContainer.requisitions = [];
      this.requisitionsContainer.disableInfiniteScroll = false;
      this.requisitionsContainer.getNext();
    }
  }

  // ngx-bootstrap's <pagination> re-emits pageChanged whenever its [totalItems]
  // input changes (e.g. after requisitionCount is updated by the very API call
  // pageChanged triggered), which without this guard re-fires getNextPage for
  // the same page in an infinite loop.
  onRequisitionPageChanged(event: any): void {
    if (!event || event.page === this.lastFetchedRequisitionPage) { return; }
    this.lastFetchedRequisitionPage = event.page;
    this.currentRequisitionPage = event.page;
    this.requisitionsContainer.getNextPage(event.page);
  }

  queryRequisitions(): void {
    this.requisitionsContainer.loadingSearchButton = true;
    if (this.requisitionsContainer.currentPromise) {
      this.genericService.cancelRequest(this.requisitionsContainer.currentPromise);
    }
    this.requisitionsContainer.requisitionsExistFlag = true;
    this.requisitionsContainer.requisitionsQueryFilter.pageNum = 1;
    this.currentRequisitionPage = 1;
    this.requisitionsContainer.requisitions = [];
    this.requisitionsContainer.disableInfiniteScroll = false;
    if (this.displayRequisitionFilterItemsSelected.length === 0) {
      this.displayFilterFlag = false;
      this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = true;
    }

    this.stateManagementStorageService.setScreenState(
      `requisitionsScreen-${this.userId}`, this.requisitionsContainer.requisitionsQueryFilter
    );
    this.stateManagementStorageService.setScreenState(
      `requisitionsScreen-displayFilter-${this.userId}`, this.displayRequisitionSelectedFilter
    );
    this.isFiltersChanged = false;
    if (this.isRowViewActive) {
      this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
    } else {
      this.requisitionsContainer.getNext();
    }
  }

  deleteRequisition(requisition: any): void {
    if (this.isRowViewActive) {
      const rowViewIndex = this.requisitionsContainer.requisitionsPerPage.findIndex(
        (req: any) => req.requisitionNumber === requisition.requisitionNumber
      );
      this.requisitionsContainer.requisitionsPerPage.splice(rowViewIndex, 1);
    } else {
      const requisitionIndex = this.requisitionsContainer.requisitions.findIndex(
        (req: any) => req.requisitionNumber === requisition.requisitionNumber
      );
      this.requisitionsContainer.requisitions.splice(requisitionIndex, 1);
    }
    this.requisitionsContainer.requisitionCount = this.requisitionsContainer.requisitionCount - 1;
  }
}
